
import React, { memo, useEffect, useRef, useState } from 'react';
import '../../Static/priceinfo.css';
import { TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button, CircularProgress } from '@mui/material';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import { selectFusiondata } from '../Selectors/TrackSelector/TrackSelector';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import { getCurrentDate } from '../../Utils/Dateutils';
import { fetchFusiondata, InsertFusionReturnEntry } from '../../Store/PHPSlice/Fusioning/fusioningApi';
import axios from 'axios';
import SOMaterialReturnEntry from '../Sale/SOMaterialReturnEntry';


const FusionReturnEntry = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const { Id } = useParams();
    const [formData, setFormData] = useState({
        fuId: Id,
        id: '',
        dt: getCurrentDate(),
        empNm: '',
        empId: '',
        ordType: '',
        soId: '',
        sono: '',
        totMtr: '',
        challanId: '',
        userId: userdata?.ID
    });
    const [soMaterial, setSoMaterial] = useState([]);

    const dispatch = useDispatch();
    const [lumpRows, setLumpRows] = useState([]);
    const [lumpTotMtr, setLumpTotMtr] = useState(0);
    const [usedTotMtr, setUsedTotMtr] = useState(0);
    const [balTotMtr, setBalTotMtr] = useState(0);
    const [baleNo, setBaleNo] = useState('');
    const [inwardData, setInwardData] = useState([]);

    const [loading, setLoading] = useState(false);

    const fusionlist = useSelector(selectFusiondata);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed

    useEffect(() => {
        dispatch(fetchFusiondata(Id));
        fetchMaterialProductionList(Id);
    }, [Id, dispatch]);


    // console.log(fusionlist);
    useEffect(() => {
        if (fusionlist?.data) {
            const item = fusionlist.data;
            const inwMemo = fusionlist.countId > 0 ? `R-${item.fmemo}-${parseFloat(fusionlist.countId) + 1}` : `R-${item.fmemo}-1`;

            setFormData(prev => ({
                ...prev,
                memo: inwMemo,
                id: item?.ID,
                dt: item?.dt,
                fmemo: item?.fmemo,
                ctinwId: item?.ctinwId,
                soId: item?.soId,
                sono: item?.sono,
                nId: item?.nId,
                numMemo: item?.numMemo,
                empId: item?.empId,
                empNm: item?.empNm,
                itemId: item?.itemId,
                itemNm: item?.itemNm,
                mcloth: item?.mcloth,
                mclothNm: item?.mclothNm,
                m1cloth: item?.m1cloth,
                m1clothNm: item?.m1clothNm,
                m2cloth: item?.m2cloth,
                m2clothNm: item?.m2clothNm,
                m3cloth: item?.m3cloth,
                m3clothNm: item?.m3clothNm,
                totqty: item?.totqty,
                sts: item?.sts,
            }));
            setInwardData(fusionlist?.info);
        }
    }, [fusionlist]);


    useEffect(() => {
        if (inwardData) {
            const updatedMat = [...soMaterial];
            const calculated = updatedMat?.map(item => {
                const rows = item?.info.row?.map((it, vidx) => {
                    const qty = parseFloat(inwardData[vidx].inwqty || 0);
                    {/* const qty = 0; */ }
                    const matgqty = parseFloat(it.matgqty);
                    const matsize = parseFloat(it.matsize);
                    const perpktqty = parseFloat(item.perpktqty);

                    let issqty = 0;
                    let issmtr = 0;
                    let issInch = 0;
                    let issmqty = 0;

                    switch (item.mtype) {
                        case "Pcs":
                            issqty = ((parseFloat(matgqty) * qty) / perpktqty).toFixed(2);
                            issmqty = parseFloat(matgqty) * qty;

                            break;

                        case "Mtr":
                            issmtr = parseFloat(matgqty) * parseFloat(matsize) * qty;
                            issInch = (issmtr * 39.3701).toFixed(2);
                            issmqty = parseFloat(matgqty) * qty;

                            break;

                        case "Inch":
                            {/* issInch = matgqty * qty; */ }
                            issInch = parseFloat(matgqty) * parseFloat(matsize) * qty;
                            issmtr = (issInch / 39.3701).toFixed(2);
                            issmqty = parseFloat(matgqty) * qty;

                            break;

                        default:
                            break;
                    }

                    return {
                        ...it,
                        issqty,
                        issmtr,
                        issInch,
                        issmqty
                    };
                });

                const totissqty = rows.reduce((acc, sum) => acc + parseFloat(sum.issqty), 0);
                const totissmtr = rows.reduce((acc, sum) => acc + parseFloat(sum.issmtr), 0);
                const totissInch = rows.reduce((acc, sum) => acc + parseFloat(sum.issInch), 0);
                const totissmqty = rows.reduce((acc, sum) => acc + parseFloat(sum.issmqty), 0);

                return {
                    ...item,
                    reoutmtr: totissmtr.toFixed(2),   // 👈 THIS is the key
                    reoutinch: totissInch.toFixed(2),
                    reoutqty: totissqty.toFixed(2),
                    reoutTotqty: totissmqty
                };
            });
            setSoMaterial(calculated);
        }
    }, [inwardData]);

    const fetchMaterialProductionList = async (id) => {
        const departNm = "FUSIONING";
        try {
            const res = await axios.get(`${baseUrl}?apicall=getMaterialProduction_Issuedata_departNm_prodid&departNm=${departNm}&prod_id=${id}`)
            // console.log(res.data);
            setSoMaterial(res.data?.data || []);
        } catch (error) {
            console.error('error', error);
        }
    };

    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };

    const handleQtyChange = (index, e) => {
        const value = parseInt(e.target.value || 0, 10);
        const updated = inwardData.map((item, i) =>
            i === index ? {
                ...item,
                inwqty: value <= item.bqty ? value : item.inwqty,
                rmqty: value <= item.bqty ? item.bqty - value : item.rmqty
            } : item
        );

        if (value <= inwardData[index].bqty) {
            setInwardData(updated);
        } else {
            alert("Inward Qty cannot be greater than Remaining Qty.");
        }
    };

    function postObj(formData, inwardData, soMaterial) {
        const totqty = inwardData?.reduce((acc, sum) => acc + parseFloat(sum.bqty), 0);
        const reqty = inwardData?.reduce((acc, sum) => acc + parseFloat(sum.inwqty), 0);
        return {
            dt: formData.dt,
            fuId: formData.fuId,
            finwMemo: formData.memo,
            empId: formData.empId,
            totqty: totqty,
            reqty: reqty,
            userId: formData.userId,
            inwardData: inwardData,
            materialData: soMaterial
        };
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        try {
            const obj = postObj(formData, inwardData, soMaterial);
            // console.log("Submitting:", obj);

            const result = await dispatch(InsertFusionReturnEntry(obj)).unwrap();
            console.log('POST request successful!', result);
            // alert("Fusion Inward added successfully");
            // window.close();

            if (result.status === "success") {
                alert(result.msg);
                window.opener.postMessage("REFRESH_PARENT", "*");
                window.close();
            } else {
                alert(result.msg);
            }
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }

    }

    const fields = [
        { name: 'dt', type: 'date' }
    ];

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };


    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1% 0%', width: '100%' }} ref={componentRef}>

                        <h3 className='centered-heading'>Fusioning Issue Return</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '15px' }}>

                            <tbody>
                                <tr>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Date</td>

                                    <td style={{ padding: '0.2% 1%', width: '150px' }}>
                                        {/* <input
                                            type="date"
                                            value={new Date().toISOString().split('T')[0]}
                                            max={new Date().toISOString().split('T')[0]}
                                            style={{ width: '100%' }}
                                        /> */}
                                        {fields.map((field) => (
                                            <DateInputComponent
                                                key={field.name}
                                                formData={formData}
                                                handleDateChange={handleDateChange}
                                                handleInputChange={handleInputChange}
                                                styled={styled}
                                                inputStyles={inputStyles}
                                                isDesktop={isDesktop}
                                                field={field}
                                            />
                                        ))}
                                    </td>
                                    <td style={{ width: '200px' }}>Fusion Inward No.</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.memo}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: '200px' }}>Employee</td>

                                    <td style={{ width: '30vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.empNm}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Date</td>

                                    <td style={{ padding: '0.2% 1%', width: '150px' }} className='dark-color'>{formData.dt}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Fusion Memo No.</td>

                                    <td style={{ width: '25vw', padding: '0 1.5%' }}>{formData.fmemo}</td>
                                    <td style={{ width: '200px' }}>Numbering Memo No.</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.numMemo}</td>

                                </tr>


                                <tr>
                                    <td style={{ width: '200px' }}>SO No.</td>

                                    <td style={{ width: '25vw', padding: '0 1.5%' }}>{formData.sono}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Item</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.itemNm}</td>
                                    <td style={{ width: '200px' }}>Main Cloth</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.mclothNm}</td>
                                </tr>

                                <tr>
                                    <td>M1 Cloth</td>

                                    <td>{formData.m1clothNm || '-'}</td>
                                    <td>M2 Cloth</td>

                                    <td>{formData.m2clothNm || '-'}</td>
                                </tr>
                                <tr>
                                    <td>M3 Cloth</td>

                                    <td>{formData.m3clothNm || '-'}</td>
                                </tr>
                            </tbody>


                        </table>

                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableHead>
                                    <TableRow className='tbl-row'>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Size</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Total Issue Qty.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Total Remaining Qty.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Inward Qty.</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Array.isArray(inwardData) && inwardData.length > 0 ? (
                                        inwardData.filter((val) => val.bqty > 0)
                                            .map((item, index) => (
                                                <TableRow key={index}>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{index + 1}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.size}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.bqty}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.rmqty}</TableCell>
                                                    <TableCell
                                                        key={index}
                                                        sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }}
                                                        align='center'
                                                    >
                                                        <input
                                                            type="text"
                                                            value={item.inwqty || 0}
                                                            onChange={(e) => handleQtyChange(index, e)}
                                                            style={{ width: '80px', padding: '1px' }}
                                                        />
                                                    </TableCell>

                                                </TableRow>
                                            ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={5} align='center'>No data available</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>

                        </TableContainer>


                        {soMaterial.length > 0 &&
                            <div style={{ marginLeft: '5%' }}>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Material Name</th>
                                            <th>Size</th>
                                            {soMaterial?.[0].info?.row.map(i => (
                                                <th key={i.size}>{i.size}</th>
                                            ))}
                                            <th>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {soMaterial.map((item, index) => {
                                            const rows = item?.info.row?.map((it, vidx) => {
                                                const qty = parseFloat(inwardData?.[vidx]?.inwqty || 0);

                                                {/* const qty = 0; */ }
                                                const matgqty = parseFloat(it.matgqty);
                                                const matsize = parseFloat(it.matsize);

                                                let issqty = 0;
                                                let issmtr = 0;
                                                let issInch = 0;
                                                let issmqty = 0;

                                                switch (item.mtype) {
                                                    case "Pcs":
                                                        issqty = parseFloat(matgqty) * qty;
                                                        issmqty = parseFloat(matgqty) * qty;

                                                        break;

                                                    case "Mtr":
                                                        issmtr = parseFloat(matgqty) * parseFloat(matsize) * qty;
                                                        issInch = (issmtr * 39.3701).toFixed(2);
                                                        issmqty = parseFloat(matgqty) * qty;

                                                        break;

                                                    case "Inch":
                                                        {/* issInch = matgqty * qty; */ }
                                                        issInch = parseFloat(matgqty) * parseFloat(matsize) * qty;
                                                        issmtr = (issInch / 39.3701).toFixed(2);
                                                        issmqty = parseFloat(matgqty) * qty;

                                                        break;

                                                    default:
                                                        break;
                                                }

                                                return {
                                                    ...it,
                                                    issqty,
                                                    issmtr,
                                                    issInch,
                                                    issmqty
                                                };
                                            });
                                            const mtype = item.mtype;

                                            {/* const totitemqty = qtyArr.reduce((acc, sum) => acc + parseFloat(sum || 0), 0); */ }
                                            const totissqty = rows.reduce((acc, sum) => acc + parseFloat(sum.issqty), 0);
                                            const totissmtr = rows.reduce((acc, sum) => acc + parseFloat(sum.issmtr), 0);
                                            const totissInch = rows.reduce((acc, sum) => acc + parseFloat(sum.issInch), 0);
                                            const totissmqty = rows.reduce((acc, sum) => acc + parseFloat(sum.issmqty), 0);
                                            return (
                                                <React.Fragment key={index}>
                                                    <tr>
                                                        <td rowSpan={6}>
                                                            {item.materialNm}
                                                            <br />
                                                            <small>({item.mtype})</small>

                                                        </td>
                                                        <td>Material Length</td>
                                                        {rows.map(i => (
                                                            <td key={i.matsize}>{i.matsize}</td>
                                                        ))}
                                                        <td></td>
                                                    </tr>

                                                    <tr>
                                                        <td>Per Size M. Qty.</td>
                                                        {rows.map(i => (
                                                            <td key={i.matsize}>{i.matgqty}</td>
                                                        ))}
                                                        <td></td>
                                                    </tr>
                                                    {/* style={{ fontWeight: 800, background: '#fccfa1' }} */}
                                                    <tr>
                                                        <td>Qty.</td>
                                                        {inwardData.map((q, i) => (
                                                            <td key={i}>{q.inwqty}</td>
                                                        ))}
                                                        {/* <td><b>{totitemqty}</b></td> */}
                                                        <td></td>
                                                    </tr>

                                                    <tr style={{ fontWeight: 800, background: '#fdd4d4' }}>
                                                        <td>Mtr.</td>
                                                        {rows.map(i => (
                                                            <td key={i.matsize}>{i.issmtr}</td>
                                                        ))}
                                                        <td><b>{totissmtr}</b></td>
                                                    </tr>

                                                    <tr style={{ fontWeight: 800, background: '#85e07c' }}>
                                                        <td>Inch.</td>
                                                        {rows.map(i => (
                                                            <td key={i.matsize}>{i.issInch}</td>
                                                        ))}
                                                        <td><b>{totissInch}</b></td>
                                                    </tr>

                                                    <tr style={{ fontWeight: 800, background: '#b4b4f7' }}>
                                                        <td>Total Qty.</td>
                                                        {rows.map(i => (
                                                            <td key={i.matsize}>{i.issmqty}</td>
                                                        ))}
                                                        <td><b>{totissmqty}</b></td>
                                                    </tr>
                                                </React.Fragment>
                                            );
                                        })}
                                    </tbody>

                                </table>


                                <table>
                                    <thead>
                                        <th>Sr.No.</th>
                                        <th>Barcode</th>
                                        <th>Material</th>
                                        <th>M type</th>
                                        <th>Issue P Qty.</th>
                                        <th>Return P Qty.</th>
                                        <th>Issue Mtr</th>
                                        <th>Return Mtr</th>
                                        <th>Issue Inch</th>
                                        <th>Return Inch</th>
                                        <th>Issue Totqty</th>
                                        <th>Return Totqty</th>
                                    </thead>
                                    <tbody>
                                        {soMaterial?.map((item, index) => (
                                            <tr key={index}>
                                                <td>
                                                    {index + 1}</td>
                                                <td>{item.barcode}</td>
                                                <td>{item.materialNm}</td>
                                                <td>{item.mtype}</td>
                                                <td>{item.outqty}</td>
                                                <td>{item.reoutqty}</td>
                                                <td>{item.outMtr}</td>
                                                <td>{item.reoutmtr}</td>
                                                <td>{item.outInch}</td>
                                                <td>{item.reoutinch}</td>
                                                <td>{item.outBoxQty}</td>
                                                <td>{item.reoutTotqty}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        }

                        {/* {soMaterial.length > 0 &&
                            <SOMaterialReturnEntry soMaterial={soMaterial} inwardData={inwardData} />
                        } */}

                        <Grid item xs={12} textAlign="center">
                            <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                {
                                    loading === true ?
                                        <><CircularProgress size="20px" /> wait...</> :
                                        "Submit"
                                }
                            </Button>
                        </Grid>
                    </div>

                </Paper>
            </Grid>
        </>
    );
};

export default FusionReturnEntry;
